import EF from 'ef/ef';
import utils from 'lib/utils';
import CourseSettingsService from 'services/course-settings-service';
import EnrollmentDataService from 'services/enrollment-data-service';
import LocaleService from 'services/locale-service';

export default class VideoServiceBase {
  constructor(view) {
    Object.assign(this, Backbone.Events);
    this.video = document.createElement('video');
    this.video.setAttribute('crossorigin', 'anonymous');
    if(view.model.has('poster')) {
      this.poster = view.model.get('poster');
    }

    this.videoId = view.model.get('video_id');

    // Defaults for the options that will be mapped to attributes on the video element
    view.model.set('options', Object.assign({
      controls: ''
    }, view.model.get('options')));

    view.model.property('options', (options) => {
      Object.keys(options).forEach((key) => {
        this.video.setAttribute(key, options[key]);
      });
    });
    view.el.querySelector(`.accessibility-wrapper`).appendChild(this.video);
  }

  initVideo(videoId, options, callbacks) {
    options = options || {};
    let metadataUrl = '';
    if(options.metadataUrl) {
      metadataUrl = options.metadataUrl;
    } else {
      metadataUrl = utils.coursePath(`video-metadata/${LocaleService.getLanguage()}/${videoId}.json`);
    }

    $.getJSON(metadataUrl).then((metadata) => {
      if(this.buildVideoPlayer(metadata, options)) {
        this.setupEvents(callbacks);
      } else {
        this.trigger('media:unplayable', { message: "This browser does not support DASH, HLS and the fallback MP4 does not exist. Can't play the video!"});
      }

    });
    this.progress = 0;
  }

  buildVideoPlayer(metadata, options) {
    const transcode = this.findLatestTranscode(metadata.transcodes);
    const mediaHost = options.customMediaHost ? CourseSettingsService.get('custom_media_host') : CourseSettingsService.get('media_host');
    const manifestUrl = `${mediaHost}/${transcode.OutputKeyPrefix}playlist-dash.mpd`;

    if(this.poster) {
      if(this.poster.startsWith('http')) {
        this.video.setAttribute('poster', this.poster);
      } else if(transcode.Outputs[0] && this.videoId) {
        const pattern = transcode.Outputs[0].ThumbnailPattern;
        // Note to future self: Replace this with String.prototype.padStart()
        // This will have to be polyfilled
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/padStart
        const frame = ('00000' + this.poster).slice(-5);
        const url = `${mediaHost}/${transcode.OutputKeyPrefix}${pattern.replace('{count}', frame)}.png`;
        this.video.setAttribute('poster', url);
      }
    }

    return {
      transcode, mediaHost, manifestUrl
    };
  }

  findLatestTranscode(transcodes) {
    transcodes = transcodes.reverse();
    return _.find(transcodes, (t) => t.Status === 'Complete');
  }

  setupEvents(callbacks) {
    this.seeking = false;
  }

  toggleMute(muted) {
    Chaplin.mediator.publish('media:mute:change', muted ? 'on' : 'off');
  }

  loadVolume() {
    return EnrollmentDataService.getData('video_volume');
  }

  saveVolume(volume) {
    EnrollmentDataService.saveData('video_volume', volume);
  }

  saveMuteState(muteState) {
    EnrollmentDataService.saveData('video_mute', muteState);
  }

  initializeMuteState() {
    const muted = EnrollmentDataService.getData('video_mute');
    if(muted === 'true' || muted === true) {
      this.mute();
    } else {
      this.unmute();
    }
  }

  onReady() {
    this.trigger('ready');
  }

  onTime(e) {
    this.trigger('time', e);
  }

  dispose() {
    if(this.video && typeof this.video.remove === 'function') {
      this.video.remove();
    }
  }

  // video-view calls these, default to no-op, let the child service handle these
  mute() { }
  unmute() { }
}
